import { useTheme } from 'styled-components';

import IconProps, { StyledPath } from 'packages/kakapo-ui-kit/assets/icons/IconProps';

export default function ArrowRightAboveIcon({ color = '#6C7680' }: IconProps) {
	const theme = useTheme() as any;

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="10"
			height="10"
			viewBox="0 0 10 10"
			style={{
				display: 'block',
			}}
		>
			<StyledPath
				strokeWidth={2}
				stroke={theme.colors[color]}
				color="transparent"
				d="M1,9 L9,1 L2,1 M9,1 L9,9"
			/>
		</svg>
	);
}
